"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalContext = void 0;
exports.setContextReplacer = setContextReplacer;
exports.setJSchemaContext = setJSchemaContext;
exports.schemaFuncText = schemaFuncText;
exports.globalContext = 'this.';
/**
 * ustawia funkcje zamiany kontekstu this w funkcjach
 */
function setContextReplacer() {
    if (exports.globalContext) {
        const gce = exports.globalContext.replace('.', '\\.');
        const rx1 = new RegExp(gce + '\\$methods', 'gm');
        const rx2 = new RegExp(gce + '\\$root', 'gm');
        const rx3 = new RegExp(gce + '\\$parent', 'gm');
        // let rx4 = new RegExp(gce + "\\$parent2", "gm");
        //let rx5 = new RegExp(gce + "\\$parent3", "gm");
        const rx6 = new RegExp(gce + '\\$obj', 'gm');
        const rx7 = new RegExp(gce + '\\$external', 'gm');
        const rx8 = new RegExp(gce + '\\$value', 'gm');
        const rx9 = new RegExp(gce + '\\$event', 'gm');
        contextReplacer = (s) => s
            .replace(rx1, '$methods')
            .replace(rx2, '$root')
            .replace(rx3, '$parent')
            //.replace(rx1, "$parent2")
            //.replace(rx1, "$parent3")
            .replace(rx6, '$obj')
            .replace(rx7, '$external')
            .replace(rx8, '$value')
            .replace(rx9, 'event');
    }
    else {
        contextReplacer = (s) => s;
    }
}
let contextReplacer = (s) => s;
setContextReplacer();
function setJSchemaContext(func) {
    let s = func.toString();
    let p = s.indexOf('=>');
    if (p > -1) {
        s = s.substring(p + 2);
    }
    else {
        p = s.indexOf('{');
        const p2 = s.lastIndexOf('}');
        s = s.substring(p + 1, p2).replace('return ', '');
    }
    s = s.trim().replace(';', '');
    p = s.indexOf('$');
    if (p > -1) {
        s = s.substring(0, p);
    }
    exports.globalContext = s;
    setContextReplacer();
    return exports.globalContext;
    // s = s.replace('$methods', '').replace(';', '');
}
/**
 * zamiana funkcji w schemacie na tekst
 * @param s funkcja
 * @returns
 */
function schemaFuncText(
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
funcText, options = {}) {
    if (typeof funcText !== 'string') {
        funcText = funcText.toString();
    }
    let isArrowFunc = false;
    let s = funcText;
    if (s.startsWith('() => ')) {
        s = s.substring(6);
        isArrowFunc = true;
    }
    else if (s.startsWith('()=>')) {
        s = s.substring(4);
        isArrowFunc = true;
    }
    const p1 = s.indexOf('{');
    const p2 = s.lastIndexOf('}');
    if (p1 > -1 && p2 > p1) {
        s = s.substring(p1 + 1, p2);
        // isArrowFunc = false;
    }
    if (!options.contextFromArg) {
        if (exports.globalContext) {
            s = contextReplacer(s);
        }
    }
    // wywalenie ?.
    // s = s.replace(/\?\./, ".");
    // $parent?
    s = s.replace(/\$parent\?\./, '$parent.');
    /*
      if (!isArrowFunc) {
          s = s.replace('return ', '$result = ')
      } else {
          s = "$result = " + s;
      }
      */
    let codeLines = s
        .split('\n')
        .map((x) => x.trim())
        .filter((x) => x.length > 0);
    if (options.removeDebugger) {
        codeLines = codeLines.filter((x) => x !== 'debogger' && x !== 'debugger;');
    }
    if (codeLines.length === 1 && !options.skipRemoveReturn /*&& codeLines[0].startsWith('$result = ')*/) {
        // let codeLine = codeLines[0].substring(10);
        let codeLine = codeLines[0];
        if (isArrowFunc)
            return codeLine;
        //if (codeLine.startsWith('return')) {
        //(!(/(return[\s\"\!\'\(\;]|return$)/).test(stext))
        // eslint-disable-next-line no-useless-escape
        const returnPos = codeLine.search(/(return[\s\"\!\'\(\;]|return$)/);
        if (returnPos == 0) {
            codeLine = codeLine.substring(6).trimStart();
            while (codeLine.endsWith(';')) {
                codeLine = codeLine.substring(0, codeLine.length - 1);
            }
            if (codeLine !== 'void 0' && codeLine !== 'undefined') {
                return codeLine;
            }
            return undefined;
        }
    }
    return codeLines;
}
//# sourceMappingURL=schemaFuncText.js.map